import { useLocation } from 'react-router';

/**
 * if within the dine-in order flow
 * checks for `dine-in` at the beginning of the pathname
 */
export const isDineInOrderFlow = (): boolean => {
  return isOrderFlow('dine-in');
};

/**
 * if within the catering order flow
 * checks for `catering` at the beginning of the pathname
 * use if you want code to be reactive to pathname changes
 */
export const useIsCateringOrderFlow = (): boolean => {
  const routeLocation = useLocation();
  return routeLocation.pathname.startsWith(`/catering/`);
};

/**
 * if within the catering order flow
 * checks for `catering` at the beginning of the pathname
 */
export const isCateringOrderFlow = (): boolean => {
  return isOrderFlow('catering');
};

/**
 * if within the off-premises order flow, i.e. pickup, curbside, or delivery
 * checks for `order` at the beginning of the pathname
 */
export const isOffPremisesOrderFlow = (): boolean => {
  return isOrderFlow('order');
};

const isOrderFlow = (path: string): boolean => {
  return window.location.pathname.startsWith(`/${path}/`);
};
